import React, { useState } from "react";
import { fetchCompletedTasksSummary } from "../../apis/apis";

export default function Summary() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [state, setState] = useState("Closed");
  const [tableData, setTableData] = useState<any[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFetchSummary = async () => {
    if (!startDate || !endDate) {
      setError("Por favor selecciona ambas fechas.");
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await fetchCompletedTasksSummary(startDate, endDate, state);

      const data = response.summary; // Accede al campo `summary`

      if (!Array.isArray(data)) {
        throw new Error("La respuesta de la API no es un array.");
      }

      setTableData(data); // Almacena los datos para la tabla
    } catch (err) {
      console.error("Error fetching summary:", err);
      setError("Error al cargar el resumen. Por favor intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-4">Resumen de Tareas Completadas</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Desde
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Hasta
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Estado
          </label>
          <select
            value={state}
            onChange={(e) => setState(e.target.value)}
            className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          >
            <option value="Closed">Cerrado</option>
            <option value="ClosedKO">Cerrado Sin Examenes</option>
            <option value="Open">Abierto</option>
            <option value="Error">Error</option>
          </select>
        </div>
      </div>
      <button
        onClick={handleFetchSummary}
        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
      >
        Generar Resumen
      </button>
      {loading && <p className="mt-4">Cargando...</p>}
      {error && <p className="mt-4 text-red-500">{error}</p>}
      {tableData && (
        <div className="mt-6">
          <table className="min-w-full border-collapse border border-gray-300">
            <thead>
              <tr>
                <th className="border border-gray-300 px-4 py-2 text-left">Email</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Tareas Completadas</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((item, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 px-4 py-2">{item.email}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.completed_tasks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
